import { UsStateCaProvince } from "__generated__/gql/graphql";
import { sortBy } from "lodash";
import { makeGetIsEnumValue } from "utils/assertions";

export const getIsState =
  makeGetIsEnumValue<UsStateCaProvince>(UsStateCaProvince);

export function nullIfNotState(value: string) {
  return getIsState(value) ? value : null;
}

export type USState = {
  name: string;
  abbreviation: UsStateCaProvince;
};

export const stateNameByAbbreviation: Record<UsStateCaProvince, string> = {
  [UsStateCaProvince.AL]: "Alabama",
  [UsStateCaProvince.AK]: "Alaska",
  [UsStateCaProvince.AS]: "American Samoa",
  [UsStateCaProvince.AZ]: "Arizona",
  [UsStateCaProvince.AR]: "Arkansas",
  [UsStateCaProvince.CA]: "California",
  [UsStateCaProvince.CO]: "Colorado",
  [UsStateCaProvince.CT]: "Connecticut",
  [UsStateCaProvince.DE]: "Delaware",
  [UsStateCaProvince.DC]: "District of Columbia",
  [UsStateCaProvince.FM]: "Federated States of Micronesia",
  [UsStateCaProvince.FL]: "Florida",
  [UsStateCaProvince.GA]: "Georgia",
  [UsStateCaProvince.GU]: "Guam",
  [UsStateCaProvince.HI]: "Hawaii",
  [UsStateCaProvince.ID]: "Idaho",
  [UsStateCaProvince.IL]: "Illinois",
  [UsStateCaProvince.IN]: "Indiana",
  [UsStateCaProvince.IA]: "Iowa",
  [UsStateCaProvince.KS]: "Kansas",
  [UsStateCaProvince.KY]: "Kentucky",
  [UsStateCaProvince.LA]: "Louisiana",
  [UsStateCaProvince.ME]: "Maine",
  [UsStateCaProvince.MH]: "Marshall Islands",
  [UsStateCaProvince.MD]: "Maryland",
  [UsStateCaProvince.MA]: "Massachusetts",
  [UsStateCaProvince.MI]: "Michigan",
  [UsStateCaProvince.MN]: "Minnesota",
  [UsStateCaProvince.MS]: "Mississippi",
  [UsStateCaProvince.MO]: "Missouri",
  [UsStateCaProvince.MT]: "Montana",
  [UsStateCaProvince.NE]: "Nebraska",
  [UsStateCaProvince.NV]: "Nevada",
  [UsStateCaProvince.NH]: "New Hampshire",
  [UsStateCaProvince.NJ]: "New Jersey",
  [UsStateCaProvince.NM]: "New Mexico",
  [UsStateCaProvince.NY]: "New York",
  [UsStateCaProvince.NC]: "North Carolina",
  [UsStateCaProvince.ND]: "North Dakota",
  [UsStateCaProvince.MP]: "Northern Mariana Islands",
  [UsStateCaProvince.OH]: "Ohio",
  [UsStateCaProvince.OK]: "Oklahoma",
  [UsStateCaProvince.OR]: "Oregon",
  [UsStateCaProvince.PW]: "Palau",
  [UsStateCaProvince.PA]: "Pennsylvania",
  [UsStateCaProvince.PR]: "Puerto Rico",
  [UsStateCaProvince.RI]: "Rhode Island",
  [UsStateCaProvince.SC]: "South Carolina",
  [UsStateCaProvince.SD]: "South Dakota",
  [UsStateCaProvince.TN]: "Tennessee",
  [UsStateCaProvince.TX]: "Texas",
  [UsStateCaProvince.UT]: "Utah",
  [UsStateCaProvince.VT]: "Vermont",
  [UsStateCaProvince.VI]: "Virgin Islands",
  [UsStateCaProvince.VA]: "Virginia",
  [UsStateCaProvince.WA]: "Washington",
  [UsStateCaProvince.WV]: "West Virginia",
  [UsStateCaProvince.WI]: "Wisconsin",
  [UsStateCaProvince.WY]: "Wyoming",

  // Canadian provinces and territories
  [UsStateCaProvince.AB]: "Alberta",
  [UsStateCaProvince.BC]: "British Columbia",
  [UsStateCaProvince.MB]: "Manitoba",
  [UsStateCaProvince.NB]: "New Brunswick",
  [UsStateCaProvince.NF]: "Newfoundland and Labrador",
  [UsStateCaProvince.NS]: "Nova Scotia",
  [UsStateCaProvince.NT]: "Northwest Territories",
  [UsStateCaProvince.NU]: "Nunavut",
  [UsStateCaProvince.ON]: "Ontario",
  [UsStateCaProvince.PE]: "Prince Edward Island",
  [UsStateCaProvince.QC]: "Quebec",
  [UsStateCaProvince.SK]: "Saskatchewan",
  [UsStateCaProvince.YT]: "Yukon",
};

const states = sortBy(
  Object.entries(stateNameByAbbreviation).map<USState>(
    ([abbreviation, name]) => ({
      name,
      abbreviation: abbreviation as UsStateCaProvince,
    }),
  ),
  (r) => r.name,
);

export default states;

export const stateAbbreviations = states.map((state) => state.abbreviation);
